
import React from 'react';
import { useEffect, useState } from 'react';

const AttendanceContext = React.createContext();

export  const AttendanceContextProvider = (props) => {

  const [currentSesson, setcurrentSesson] = useState(() => {
    return localStorage.getItem("attendanceCurrentSession") || "Autumn";
  });
  const [getSelectedStudent, setSelectedStudent] = useState("");

  useEffect(() => {
    localStorage.setItem("attendanceCurrentSession", currentSesson);
  }, [currentSesson]);

  return(
    <AttendanceContext.Provider 
      value={{ 
        currentSesson, 
        setcurrentSesson, 
        getSelectedStudent, 
        setSelectedStudent 
      }}
    >
      {props.children}
    </AttendanceContext.Provider>
  )
}

export default AttendanceContext;
